import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const styles = () => ({
  root: {},
});

const LinkedAccountErrorViewButton = ({
  className,
  classes,
}) => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  return (
    <RoundedButton
      className={classNames(classes.root, className)}
      onClick={() => {
        return loadPageContentLink(pageContentResource.relationship(fr.relationships.linkedAccountErrorView.name).link('related'));
      }}
    >
      {'Linked Account Errors'}
    </RoundedButton>
  );
};

LinkedAccountErrorViewButton.defaultProps = {
  className: '',
};

LinkedAccountErrorViewButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinkedAccountErrorViewButton);
